// ToastNotification.js
import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const ToastNotification = () => {
  return (
    <ToastContainer
      position="top-center"
      autoClose={5000}
      hideProgressBar
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
    />
  );
};

export const showToast = (message, type = 'default') => {
  const options = {
    autoClose: 3000,
    // You can customize other options here if needed
  };

  switch (type) {
    case 'success':
      toast.success(message, { ...options, className: 'showToast-success-custom' });
      break;
    case 'warn':
      toast.warning(message, { ...options, className: 'gl-bg-orange' });
      break;
    case 'error':
      toast.error(message, { ...options, className: 'showToast-error-custom' });
      break;
    default:
      toast(message, options);
      break;
  }
};

export default ToastNotification;
